import React from 'react';
import Button from "antd/lib/button";
import PropTypes from 'prop-types';
import { addBlock } from "../actions.js";
import { connect } from "react-redux";
import { generateNextBlock } from "./util.js";
import "./MineButton.css";

const MineButton = props => {
  return (
    <Button
      className="mine-button animate"
      icon="plus"
      onClick={() => {
        const { latestBlock, newBlockData, peer, addBlock } = props;
        const nextBlock = generateNextBlock(latestBlock, newBlockData);
        addBlock(nextBlock, peer);
      }}
    >
      <span 
        style={{
          marginLeft: "7.5px",
          color: "white"
        }}
      >
        ADD NEW BLOCK
      </span>
    </Button>
  );
};

MineButton.propTypes = {
  newBlockData: PropTypes.string,
  peer: PropTypes.string
};

function mapDispatchToProps(dispatch) {
  return {
    addBlock: (block, peer) => {
      dispatch(addBlock(block, peer));
    }
  };
}

const MineButtonContainer = connect(null, mapDispatchToProps)(MineButton);

export default MineButtonContainer;


// WEBPACK FOOTER //
// ./src/Mine/MineButton.js